









































import { Vue, Component } from 'vue-property-decorator';

import { FilledButton } from '@/components/molecules';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: { FilledButton, Typography }
})
export default class InviteCustomerInStoreEmptyState extends Vue {
  get tPrefix() {
    return 'inviteCustomerInStore.emptyState';
  }

  onClickCTA() {
    this.$emit('nextStep');
  }
}
